<template>

  <v-toolbar app="app" dense="dense" fixed="fixed" clipped-left="clipped-left">
    <svgicon width="24px" name="menu" @click="toggleMenu" title="Toggle the menu"></svgicon>
    <img id="header-logo" @click="$router.push('/')" src="@/assets/logo.png" />
    <v-toolbar-title id="header-description-part">
      <div id="header-name" @click="$router.push('/')">Rematch</div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <CountrySelector class="mr-4"/>
    <EnvSelector id="env-selector" class="mr-2"></EnvSelector>
    <svgicon class="disconnect" name="exit-to-app" @click="disconnect" title="Disconnect"></svgicon>
  </v-toolbar>

</template>

<script>

import CountrySelector from '@/components/CountrySelector.vue'
import EnvSelector from '@/components/EnvSelector'
import Button from '@/components/common/Button'
import '@/assets/icons/exit-to-app'
import '@/assets/icons/menu'

export default {
  name: 'HeaderBar',
  components: {
    CountrySelector,
    EnvSelector,
    Button
  },
  props: ['value'],
  methods: {
    disconnect () {
      this.$store.dispatch('disconnect')
        .then(() => this.$router.push('/login'))
        .catch(() => this.$router.push('/login'))
    },
    toggleMenu () {
      this.$emit('toggle-menu')
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../styles/main-colors';

.container {
  width: 100%;
  height: 100%;

  display: grid;
  grid-template-columns: 90px 1fr auto auto;
  grid-template-rows: 1fr;
  //grid-template-areas: "logo description env";
  grid-column-gap: 15px;
  align-items: center;

  background-color: $background-light;
}

.shadow-block {
  box-shadow: 0px 0px 10px 0px rgba($background-dark, 0.3);
}

#header-description-part {
  grid-column: 2 / 3;
  justify-self: start;

  display: grid;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  grid-column-gap: 10px;
  align-items: center;
  margin-left: 10px;
}

#header-logo {
  width: 36px;
  height: auto;
  margin-left: 24px;
  cursor: pointer;
}

#header-name {
  font-family: 'League Spartan';
  font-size: 16px;
  margin-top: 0.25em;
  cursor: pointer;
}

#env-selector {
  grid-column: 3 / 4;
}

.line-separator {
  width: 1px;
  height: 30px;
  background-color: rgba($bolt-fish, 0.2);
  margin: 0 10px 0 10px;
}

.disconnect {
  cursor: pointer;
  align-self: center;
  fill: $background-dark;
  width: auto;
  height: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/HeaderBar.vue